import { IsValidNumber } from '../global/util';

const getDateTimeFormat = (date: number): string => {
  const day = new Date(date).getDate();
  const month = new Date(date);
  const monthName = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(month);
  const year = new Date(date).getFullYear();
  return `${monthName} ${day}, ${year}`;
};

const consoleLogResponse = async (response: Response) => {
  const respData = await response.json();
  console.debug(`${response.status}: ${respData}`);
  return;
}

const asCurrency = (price: number) => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'CAD',
  });
  if (!IsValidNumber(price)) price = 0;
  return formatter.format(price);
};


const StringUtils = {
  asCurrency,
  getDateTimeFormat,
  consoleLogResponse
}

export default StringUtils